<div class="modal-wrapper">

  <div id="limit-container">
    <ion-grid>
      <ion-row>
        <ion-col size="12">
          <h5 class="modal-title">Cambios a publicar</h5>
          <mat-divider></mat-divider>
          <p *ngIf="rootName">Se publicará {{ rootName }} con todas sus subáreas. Los borradores ya se han guardado.</p>
        </ion-col>

        <ion-col size="12" *ngIf="preview.areas">
          <div class="area-change-tree-scroll">
            <ng-container *ngTemplateOutlet="areaTree; context: { $implicit: preview.areas }"></ng-container>
          </div>
        </ion-col>

        <ion-col size="12" *ngIf="!preview.areas && preview.added.length">
          <p class="diff-line diff-added"><span class="diff-symbol">+</span> Nuevo: <b>{{ preview.added.join(', ') }}</b></p>
        </ion-col>
        <ion-col size="12" *ngIf="!preview.areas && preview.removed.length">
          <p class="diff-line diff-removed"><span class="diff-symbol">&ndash;</span> Retirado: <b>{{ preview.removed.join(', ') }}</b></p>
        </ion-col>
        <ion-col size="12" *ngIf="!preview.areas && preview.modified.length">
          <p class="diff-line diff-modified"><span class="diff-symbol">~</span> Modificado: <b>{{ preview.modified.join(', ') }}</b></p>
        </ion-col>

        <ion-col size="12" *ngIf="!preview.hasChanges">
          <p>No hay cambios pendientes de publicación.</p>
        </ion-col>
      </ion-row>

      <ion-row id="limit-container-footer">
        <ion-col size="12">
          <button (click)="confirm()" type="button" mat-raised-button color="primary" [disabled]="!preview.hasChanges">Publicar</button>
          <button (click)="cancel()" type="button" mat-raised-button color="warn">Cancelar</button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
</div>

<ng-template #areaTree let-areas>
  <ul class="area-change-tree">
    <li *ngFor="let area of areas">
      <h6 class="area-change-name">{{ area.name }}
        <span *ngIf="area.status" class="area-change-status">
          {{ area.status === 'added' ? 'Añadida' : area.status === 'removed' ? 'Retirada' : 'Modificada' }}
        </span>
      </h6>
      <p class="diff-line diff-added" *ngIf="area.added.length"><span class="diff-symbol">+</span> Añadidas: <b>{{ area.added.join(', ') }}</b></p>
      <p class="diff-line diff-removed" *ngIf="area.removed.length"><span class="diff-symbol">−</span> Retiradas: <b>{{ area.removed.join(', ') }}</b></p>
      <p class="diff-line diff-modified" *ngIf="area.modified.length"><span class="diff-symbol">~</span> Modificadas: <b>{{ area.modified.join(', ') }}</b></p>
      <ng-container *ngIf="area.children.length" [ngTemplateOutlet]="areaTree" [ngTemplateOutletContext]="{ $implicit: area.children }"></ng-container>
    </li>
  </ul>
</ng-template>
